<div class="img-container">
  <img *ngIf="imgUrl" [src]="imgUrl" alt="">
</div>